import { render, staticRenderFns } from "./JewelryItem.vue?vue&type=template&id=6a56a0cb&scoped=true"
import script from "./JewelryItem.vue?vue&type=script&lang=js"
export * from "./JewelryItem.vue?vue&type=script&lang=js"
import style0 from "./JewelryItem.vue?vue&type=style&index=0&id=6a56a0cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56a0cb",
  null
  
)

export default component.exports